// removed by extract-text-webpack-plugin
module.exports = {"DeepTableRow":"_3cBrLjKuFs","TableRow":"_2gkC3BCNmX","isAccordionTitle":"_385eyGP-GG","TableCell":"a5OqLV8zGx","TableActionsTooltip":"_3p9r2QZRHU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeepTableSlatePlugin/TableSlatePlugin.scss
// module id = 65
// module chunks = 0